import { ScheduleType } from 'modules/domains/campaign';
import {
  SaveExperimentSettingsResponse,
  TakeoverExperimentContextState,
  TestStrategy,
} from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialTakeoverExperimentContextState: TakeoverExperimentContextState = {
  isBlastCampaign: false,
  isTriggerCampaign: false,
  isRunningExperiment: false,
  isInAppMessageMedium: false,
  isSendTimeExperiment: false,
  isSTOExperiment: false,
  isVariantNotEditable: false,
  isExperimentSaving: false,
  campaignSchedulerMsgParams: {
    scheduleType: ScheduleType.ProjectTimeZone,
  },
  fromNameAndSenderMetaInfo: {
    useDynamicSenders: false,
    emailSenders: [],
  },
  holdoutMetaInfo: {
    hasHoldOutGroup: false,
    holdOutGroupSize: 0,
    attributionPeriodHours: 0,
  },
  triggerCampaignMetaInfo: {
    testStrategy: TestStrategy.SUBSET_USERS,
    testSendsPerVariation: 0,
  },
  blastCampaignMetaInfo: {
    testStrategy: TestStrategy.SUBSET_USERS,
    testDurationHours: 0,
    testDurationMinutes: 0,
    testSizePercentage: 0,
  },
  sendTimeMetaInfo: {
    setSendTimeStartTimeZone: noop,
    setSendTimeUseRecipientTimeZones: noop,
    sendTimeStartTimeZone: '',
    sendTimeStartTimeZoneAbbr: '',
    sendTimeUseRecipientTimeZones: false,
    sendTimeOfAllVariants: [],
    controlStartTime: '',
    projectTimeZone: '',
    scheduleDateRange: {},
  },
  overlay: {
    isOverlayEnable: false,
    setIsOverlayEnable: noop,
  },
  unsavedChanges: {
    setUnsavedVariantList: noop,
    setUnsavedSettings: noop,
    unsavedVariantModal: noop,
    variantList: false,
    settings: false,
  },
  reFetch: {
    variantList: noop,
  },
  formActions: {
    saveDirtyVariantCard: {
      trigger: false,
      onSuccess: noop,
      onError: noop,
    },
    saveDirtyExperimentSettings: {
      trigger: false,
      onSuccess: noop,
      onError: noop,
    },
    resetDirtyVariantCard: false,
    dispatchSaveDirtyVariantCard: noop,
    asyncDispatchSaveDirtyVariantCard: () => new Promise((resolve) => resolve('')),
    dispatchSaveDirtyExperimentSettings: noop,
    asyncDispatchSaveDirtyExperimentSettings: () => new Promise((resolve) => resolve('')),
    dispatchResetDirtyVariantCard: noop,
  },
  saveExperiment: () => new Promise((resolve) => resolve({} as SaveExperimentSettingsResponse)),
};

export const TakeoverExperimentContext = createContext(initialTakeoverExperimentContextState);

export const useTakeoverExperimentContext = () => useContext(TakeoverExperimentContext);
